<template>
  <div
    :style="{ width: setWidth, background: setImg, height: setHeight }"
    class="header animate__animated"
    :class="{ animate__fadeInDown: show }"
    ref="header"
  >
    <slot></slot>
  </div>
</template>

<script>
const design = process.env.VUE_APP_DESIGN;
export default {
  props: {
    width: {
      type: Number,
      default: 1974,
    },
    height: {
      type: Number,
      default: 121,
    },
    backgroundImg: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      show: false,
    };
  },

  computed: {
    setWidth() {
      return (this.width * 10) / design + "rem";
    },
    setHeight() {
      return (this.height * 10) / design + "rem";
    },
    setImg() {
      return `url(${this.backgroundImg}) no-repeat center center`;
    },
  },
  mounted() {
    this.$refs.header.addEventListener("animationend", () => {
      this.$emit("finish");
    });
  },
};
</script>

<style lang="less" scoped>
@import url("../../../comment/comment.less");
.header {
  margin: 0 auto;
  background-size: 100% 100% !important;
  opacity: 1;
  transform: translateY(-100px);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: 99;
}
</style>
